import { Dispatch } from 'redux'

import { getAll, update, create, destroy } from 'redux/api/Accounts'
import * as UserEvents from 'redux/api/internal/UserEvents'

import * as actions from './actions'
import { toggleSnackbarOpen } from 'redux/actions/Snackbar'

import { PatchAccountBody, PostAccountBody } from 'types/GlobalAccount'
import { Action } from 'types/GlobalUserEvents'
import { SnackbarMessage } from 'types/GlobalSnackbar'

import { useThunkActions } from 'redux/actions/useThunkActions'

export function tryGetAllAccounts(dispatch: Dispatch) {
  dispatch(actions.getAll())

  getAll()
    .then((response) => {
      dispatch(actions.getAllSuccess(response.data))
    })
    .catch(() => {
      dispatch(actions.getAllFailed())
    })
}

export function tryUpdateUser(id: string, body: PatchAccountBody) {
  return (dispatch: Dispatch) => {
    dispatch(actions.update())

    update(id, body)
      .then((response) => {
        dispatch(actions.updateSuccess(response.data.data))

        dispatch(toggleSnackbarOpen(SnackbarMessage.UserUpdated))
      })
      .catch(() => {
        dispatch(actions.updateFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.UserUpdatedFailed))
      })
  }
}

export function tryCreateUser(body: PostAccountBody) {
  return (dispatch: Dispatch) => {
    dispatch(actions.create())

    create(body)
      .then((response) => {
        UserEvents.log({
          action: Action.INVITE_SENT_TO_HOMEPAL,
          context: null,
          dashboard_id: null,
          dashboard_group_id: null
        })

        dispatch(actions.createSuccess(response.data.data))

        dispatch(toggleSnackbarOpen(SnackbarMessage.UserCreated))
      })
      .catch(() => {
        dispatch(actions.createFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.UserCreatedFailed))
      })
  }
}

export function tryDeleteUser(id: string) {
  return (dispatch: Dispatch) => {
    dispatch(actions.destroy())

    destroy(id)
      .then((response) => {
        dispatch(actions.destroySuccess({ id, groups: response.data.data }))

        dispatch(toggleSnackbarOpen(SnackbarMessage.UserDeleted))
      })
      .catch(() => {
        dispatch(actions.destroyFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.UserDeletedFailed))
      })
  }
}

export const useAccountActions = () => {
  return {
    tryCreateUser: useThunkActions(tryCreateUser),
    tryDeleteUser: useThunkActions(tryDeleteUser),
    tryUpdateUser: useThunkActions(tryUpdateUser)
  }
}
